export const SET_PAYSLIP_LOADING = "SET_PAYSLIP_LOADING";
export const SET_PAYSLIP_SELECTED_FILES = "SET_PAYSLIP_SELECTED_FILES";
export const SET_PAYSLIP_STEP = "SET_PAYSLIP_STEP";

export const PREVIEW_PAYSLIPS_REQUEST = "PREVIEW_PAYSLIPS_REQUEST";
export const PREVIEW_PAYSLIPS_SUCCESS = "PREVIEW_PAYSLIPS_SUCCESS";
export const PREVIEW_PAYSLIPS_FAILURE = "PREVIEW_PAYSLIPS_FAILURE";

export const CONFIRM_PAYSLIPS_IMPORT_REQUEST = "CONFIRM_PAYSLIPS_IMPORT_REQUEST";
export const CONFIRM_PAYSLIPS_IMPORT_SUCCESS = "CONFIRM_PAYSLIPS_IMPORT_SUCCESS";
export const CONFIRM_PAYSLIPS_IMPORT_FAILURE = "CONFIRM_PAYSLIPS_IMPORT_FAILURE";

export const FETCH_MY_PAYSLIPS_REQUEST = "FETCH_MY_PAYSLIPS_REQUEST";
export const FETCH_MY_PAYSLIPS_SUCCESS = "FETCH_MY_PAYSLIPS_SUCCESS";
export const FETCH_MY_PAYSLIPS_FAILURE = "FETCH_MY_PAYSLIPS_FAILURE";

export const FETCH_PAYSLIP_COVERAGE_REQUEST = "FETCH_PAYSLIP_COVERAGE_REQUEST";
export const FETCH_PAYSLIP_COVERAGE_SUCCESS = "FETCH_PAYSLIP_COVERAGE_SUCCESS";
export const FETCH_PAYSLIP_COVERAGE_FAILURE = "FETCH_PAYSLIP_COVERAGE_FAILURE";

export const REMOVE_PAYSLIP_PREVIEW_LINE = "REMOVE_PAYSLIP_PREVIEW_LINE";
export const RESET_PAYSLIP_IMPORT = "RESET_PAYSLIP_IMPORT";

export const setPayslipLoading = (loadingAction = null) => ({
    type: SET_PAYSLIP_LOADING,
    payload: loadingAction,
});

export const setPayslipSelectedFiles = (files) => ({
    type: SET_PAYSLIP_SELECTED_FILES,
    payload: files,
});

export const setPayslipStep = (step) => ({
    type: SET_PAYSLIP_STEP,
    payload: step,
});

export const previewPayslipsRequest = (files) => ({
    type: PREVIEW_PAYSLIPS_REQUEST,
    payload: files,
});

export const previewPayslipsSuccess = (rows) => ({
    type: PREVIEW_PAYSLIPS_SUCCESS,
    payload: rows,
});

export const previewPayslipsFailure = (error) => ({
    type: PREVIEW_PAYSLIPS_FAILURE,
    payload: error,
});

export const confirmPayslipsImportRequest = (tempIds) => ({
    type: CONFIRM_PAYSLIPS_IMPORT_REQUEST,
    payload: tempIds,
});

export const confirmPayslipsImportSuccess = (summary) => ({
    type: CONFIRM_PAYSLIPS_IMPORT_SUCCESS,
    payload: summary,
});

export const confirmPayslipsImportFailure = (error) => ({
    type: CONFIRM_PAYSLIPS_IMPORT_FAILURE,
    payload: error,
});

export const fetchMyPayslipsRequest = () => ({
    type: FETCH_MY_PAYSLIPS_REQUEST,
});

export const fetchMyPayslipsSuccess = (payslips) => ({
    type: FETCH_MY_PAYSLIPS_SUCCESS,
    payload: payslips,
});

export const fetchMyPayslipsFailure = (error) => ({
    type: FETCH_MY_PAYSLIPS_FAILURE,
    payload: error,
});

export const fetchPayslipCoverageRequest = (period) => ({
    type: FETCH_PAYSLIP_COVERAGE_REQUEST,
    payload: period,
});

export const fetchPayslipCoverageSuccess = (coverage) => ({
    type: FETCH_PAYSLIP_COVERAGE_SUCCESS,
    payload: coverage,
});

export const fetchPayslipCoverageFailure = (error) => ({
    type: FETCH_PAYSLIP_COVERAGE_FAILURE,
    payload: error,
});

export const removePayslipPreviewLine = (tempId) => ({
    type: REMOVE_PAYSLIP_PREVIEW_LINE,
    payload: tempId,
});

export const resetPayslipImport = () => ({
    type: RESET_PAYSLIP_IMPORT,
});
